const APPLY_CHANGES_INTENT_RE = /^\s*apply\s+changes?\s*[.!]?\s*$/i;

// The model is instructed to tell the user to click or type Apply and has no
// tool that applies for them. The composer checks typed messages against this
// so they aren't bounced back as "please click Apply".
export function isApplyChangesIntent(message: string): boolean {
  return APPLY_CHANGES_INTENT_RE.test(message);
}
